import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { get, map, upperFirst } from 'lodash';
import { mapProps } from 'recompose';

export const enhance = mapProps(({ facility, phone }) => ({
	facilitySchema: {
		'@context': 'http://schema.org',
		'@type': 'SelfStorage',
		'@id': `${facility.url}#`,
		url: facility.url,
		name: facility.name,
		image: facility.images.length
			? `https://images.selfstorage.com/small-compress/${facility.images[0]}`
			: '',
		telephone: get(phone, 'formattedNumber'),
		address: {
			'@type': 'PostalAddress',
			streetAddress: `${facility.location.streetAddress1}${facility.location.streetAddress2 ? `, ${facility.location.streetAddress2}` : ''}`,
			addressLocality: facility.location.city,
			addressRegion: facility.location.state,
			postalCode: facility.location.zip,
		},
		...(get(facility, 'reviews.average') &&
			get(facility, 'reviews.number') && {
				aggregateRating: {
					'@type': 'AggregateRating',
					worstRating: 0,
					bestRating: 5,
					ratingValue: facility.reviews.average,
					reviewCount: facility.reviews.number,
				},
			}),
		openingHours: facility.inNetwork
			? map(
					get(facility, 'hours.office', []),
					(hour, key) =>
						`${upperFirst(key.substr(0, 2))} ${hour.open}-${hour.closed}`,
				)
			: '',
	},
}));

export function FacilitySchema({ facilitySchema }) {
	return (
		<Helmet>
			<script type="application/ld+json">
				{JSON.stringify(facilitySchema)}
			</script>
		</Helmet>
	);
}

FacilitySchema.propTypes = {
	facilitySchema: PropTypes.object.isRequired,
};

export default enhance(FacilitySchema);
